import styled from '@emotion/styled'
import { Theme, palette } from '@yuno/design-system-web'
import { Icon } from '@yuno/design-system-web'
import { TDrawerMessages } from '../../../../typings/pages'

const WrapperSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const SuccessTitle = styled.span(({ theme }: { theme?: Theme }) => ({
  ...theme.typography.base.bold,
  color: theme.palette.neutral.black,
  margin: `10px 0`,
}))

const SuccessSubtitle = styled.span(({ theme }: { theme?: Theme }) => ({
  ...theme.typography.tiny.regular,
  color: theme.palette.grey['5'],
  margin: '0px 30px',
  textAlign: 'center',
}))

const DrawerMessages = ({
  icon = 'CheckCircle',
  title,
  subtitle,
  paramSubtitle = '',
  color = palette.vivid.emerald,
}: TDrawerMessages) => {
  return (
    <WrapperSuccess>
      <Icon color={color} name={icon} weight="fill" size="64px" />
      <SuccessTitle>{title}</SuccessTitle>
      <SuccessSubtitle>{subtitle}</SuccessSubtitle>
      {paramSubtitle?.length > 0 && (
        <SuccessSubtitle>{`${paramSubtitle}.`}</SuccessSubtitle>
      )}
    </WrapperSuccess>
  )
}

export default DrawerMessages
